
<template>
	<section>			
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
			<!-- @keyup.enter.native="getMember" -->
				<el-form-item>
					<el-input  v-model="filters.Name"  @keyup.enter.native="getMember" placeholder="姓名"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="width:100%; height:100%;" type="primary" v-on:click="getMember" icon="el-icon-search">查询</el-button>
				</el-form-item>
				<!-- <el-form-item>
					<el-button type="warning" @click="change">变更教练</el-button>
				</el-form-item>			 -->
			</el-form>
		</el-col>

		<!--列表-->
		<el-table  :data="Members" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width:1702px">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<!-- <el-table-column type="id" width="60" hidden>
			</el-table-column> -->
			<!-- <el-table-column prop="Number" label="教练编号" width="120" sortable>
			</el-table-column> -->
            <el-table-column prop="CardNumber" label="会员卡号" width="120" sortable>
			</el-table-column>
			<el-table-column prop="MemberName" label="会员名称" width="120" sortable>
			</el-table-column>
            <el-table-column prop="CreationTime" label="重置时间" width="200" sortable>
			</el-table-column>
			<!-- <el-table-column prop="State" label="状态" min-width="90" :formatter="formatState" sortable>
			</el-table-column> -->
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
			<!-- <el-table-column label="操作" width="200" fixed="right">
				<template  slot-scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column> -->
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-tag>当前共{{Count}}条记录</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

  <!-- <el-dialog  title="请检查读卡器是否连接" custom-class style="width:100%;margin: 0 auto;padding-top: 0px;padding-right: 0.25em;padding-bottom: 2ex;padding-left: 0px;" @close='closeing'   v-model="Machine" :close-on-click-modal="false" >
     <el-row >
      <el-col :span="25" >
      
      <div >
       
          	<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true"  style="float: right;" @submit.native.prevent>
				<el-form-item >
                    					<el-button  type="primary" style="float:right" v-on:click="changeSubmit" icon="el-icon-search">确认变更</el-button>

                <el-select style="width:40%;float:right;margin-right:10px" v-model="CoachId" clearable filterable placeholder="选择或搜索教练">
                 <el-option
               v-for="item in options"
               :key="item.Id"
                  :label="item.Name"
               :value="item.Id">
                  </el-option>
                   </el-select>
					<input  :autofocus="focusvalue" ref="siteInput"  class="input" style="width:30%;float:right;margin-right:10px" v-model="inputIdCard"  clearable   placeholder="卡号"></input>
				</el-form-item>
				
			</el-form>
		</el-col>
        </div>
      </div>
   
    </el-col>
   </el-row>	
  </el-dialog> -->
	</section>
</template>

<script>
	import util from '../../common/js/util'
import {mapGetters} from 'vuex';

	//import NProgress from 'nprogress'
	import { getResetCardLogList ,ReplaceCoach } from '../../api/api';

	export default {
		data() {
			return {
				filters: {
					Name: ''
				},
		
				Count:0,
				options:[],
				Members:[],
				total: 0,
				page: 0,
				listLoading: false,
				sels: [],//列表选中列

                 Machine:false,
                 inputIdCard:'',
                 focusvalue:false,
                 show:true,
                 CoachId:''
			}
		},
		methods: {
           
           ...mapGetters(['getuserstate']),
          
			formatDate: function (row, column) {
				return util.formatDate.format(new Date(row.Birthday), 'yyyy-MM-dd');
			},

			handleCurrentChange(val) {
				this.page = val;
				this.getMember();
			},
			getMember() {

               if(JSON.parse(this.getuserstate()).UserLevel!=1) 
               {
                                this.$message({
				            	message: '您的用户级别不够没有查询权限',
					          	type: 'error'
                                });
                                return;
               }
				let para = {
					PageIndex: this.page-1,					
					PageSize:10,
					Name:this.filters.Name
				};
				this.listLoading = true;
				//NProgress.start();
				getResetCardLogList(para).then((res) => {
					this.total = res.data.TotleCount;
					this.Members =res.data.Data;
                    this.Count=res.data.TotleCount;
					this.listLoading = false;
					//NProgress.done();
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},								
			selsChange: function (sels) {
				this.sels = sels;
			},

   closeDialog(){
        // this.inputIdCard="";
        alert(111);
    //   this.onCellClick(event);

    },
    closeing()
    {
                    this.getMember();
    },
   onCellClick(event)
   {
      this.$nextTick(function(){
         this.$refs['siteInput'].focus();
          // this.$(event.target).children().find("input").focus();
      })
   },
		},
		mounted() {
            this.getMember();
			// this.getCount();
		}
	}

</script>

<style scoped>
 /* .el-form-item {
    margin-bottom: 22px;
    height: 18px;
    } */
	/* .el-input__inner {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
	width: 300px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
} */
.input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}

</style>


// WEBPACK FOOTER //
// ResetLog.vue?1948955c